import React from 'react';
import Init from './init';
import Template from './template';

const TextArea = (props) => (
  <Init {...props} Template={Template} />
);

export default TextArea;
